/**
 * Fill in the Blanks - form exports and hardcoded slug.
 * Registration is handled centrally in content-prompt/src/index.ts.
 */

export const FILL_IN_THE_BLANKS_SLUG = 'gap_typing';

export { FillInTheBlanksForm } from './FillInTheBlanksForm';
export type {
    FITBMediaType,
    FITBSourceType,
    FillInTheBlanksFormState,
} from './types';
export { MEDIA_OPTIONS, DEFAULT_FORM_STATE } from './types';
export { QUESTION_TYPE_PRESETS, QUICK_CREATE_TEMPLATES } from './config';
export type { QuickCreateTemplate } from './config';
